export default __webpack_public_path__ + "media/images/custom_themes/landing_page_image-93874caf26da98e61677de993a700a3e.png";